<template>
  <WizardLayout>
    <template #title>Pick the service closest to what you need.</template>
    <div class="d-flex flex-column mt-1">
      <SearchBar v-model="searchFilter" debounce clearable class="mt-2">
        <template #results>
          <div class="text-center font-italic" style="font-size: 14px;">
            {{ filtered.length }} results found
          </div>
        </template>
      </SearchBar>

      <div v-if="filteredCount > 0"
        class="ma-2 pa-3 rounded white" 
        style="position: relative; overflow-y: auto"
      >
        <div class="d-flex flex-wrap" style="gap: 12px">
          <ServiceButton 
            v-for="service in filtered" 
            :key="service.service_id"
            :service="service"
            class="small"
            @click="onClick(service.service_id)"
          />
        </div>
      </div>
    </div>
  </WizardLayout>
</template>

<script>
import SearchBar from '@/components/SearchBar'
import ServiceButton from '../../ServiceButton';
import { WizardLayout } from '@/layouts';

import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'QRCategoryView',

  components: { SearchBar, ServiceButton, WizardLayout },

  data: () => ({
    loading: false,

    searchFilter: '',
  }),

  computed: {
    ...mapGetters('services', ['all']),
    ...mapGetters('qr', ['request']),

    filtered() {
      const filt = this.searchFilter?.trim()?.toLowerCase() || ''

      return this.all.filter( service => 
        service.service.toLowerCase().includes(filt) ||
        service.categories.find( category => category.name.toLowerCase().includes(filt))
      )
    },

    filteredCount() { return this.filtered.length || 0 },
  },

  methods: {
    ...mapActions('services', ['loadAll']),
    ...mapActions('qr', ['setService']),

    onClick(service_id) {
      this.setService({ service_id })
      this.$router.replace({ name: 'wizard/property' })
    },
  },

  async created() {
    this.searchFilter = this.$route.query.s || ''

    this.loading = true
    
    const result = await this.loadAll()
    if (!result.ok) {
      this.$router.replace({ name: 'link' })
    }
    
    this.loading = false
  }
}
</script>